import React, { useContext, useState, useEffect } from 'react'
import { Button } from '@material-ui/core'
import { ButtonSecondaryOutlined } from '@flatsy/core/MaterialUi/Button'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import { SubBody1 } from '@flatsy/core/MaterialUi/Typo'
import i18n from '@flatsy/utils/translations'
import useStyles from './Style'
import { FileContext } from '../../Context'
import ArrowStep4 from '../Arrow/Step4'

const Footer: React.FC = () => {
  const { Uppy, upload } = useContext(FileContext)
  const classes = useStyles()
  const [showArrow, setShowArrow] = useState(false)

  useEffect(() => {
    if (
      Uppy &&
      !Uppy.hasEmptyKind() &&
      Uppy.formatedFiles &&
      Object.keys(Uppy?.formatedFiles).length > 0
    ) {
      setTimeout(() => {
        setShowArrow(true)
      }, 10)
    }
  }, [Uppy])

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <img className={classes.illustration} src={FlatsyTheme.image.padlock} alt="illustration" />
        <SubBody1 className={classes.content}>
          {i18n.t(
            'the_submission_of_your_documents_is_secured_the documents_will_not_be_stored_in_respect_of'
          )}{' '}
          <a href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article17">
            {i18n.t('article_17_right_to_erasure').toLowerCase()}
          </a>{' '}
          {i18n.t('right_to_be_forgottent_of_the_GDPR')}
        </SubBody1>
      </div>
      <div className={classes.buttonContainer}>
        <ArrowStep4 show={showArrow} />
        <ButtonSecondaryOutlined onClick={upload.close}>{i18n.t('cancel')}</ButtonSecondaryOutlined>
        <Button
          onClick={Uppy?.triggerUpload}
          disabled={Uppy?.hasEmptyKind()}
          variant="contained"
          color="primary"
          disableElevation
        >
          {i18n.t('send_documents')}
        </Button>
      </div>
    </div>
  )
}

export default Footer
